export const customerTasksList = {
  noTasksLabel: {
    en: 'No pending tasks',
    nb: 'Ingen nye oppgaver',
    nn: 'Ingen nye oppgaver',
  },
  historyLabel: {
    en: 'History',
    nb: 'Historikk',
    nn: 'Historikk',
  },
  somethingWentWrong: {
    en: 'Something went wrong, please try again later',
    nb: 'Noe gikk galt, vennligst prøv igjen senere',
    nn: 'Noko gjekk gale, vennligst prøv igjen seinare',
  },
  draftDeletionMessage: {
    en: 'Drafts will be automatically deleted 90 days after the last change.',
    nb: 'Kladder vil automatisk slettes 90 dager etter siste endring.',
    nn: 'Kladdar vil automatisk bli sletta 90 dagar etter siste endring.',
  },
} as const;
